<template>
  <div class="device">
    <div class="device-list">
      <ul>
        <li>
          <div class="img">
            <img src="@/assets/tupian.png" alt="">
          </div>
          <div class="detail">
            <span>设备描述</span>
            <p>本施工队自建厂房，自备1500目1.8m*6安全网1000张，钢管2吨，脚手架500套。</p>
          </div>
        </li>
        <li>
          <div class="img">
            <img src="@/assets/tupian.png" alt="">
          </div>
          <div class="detail">
            <span>设备描述</span>
            <p>本施工队自建厂房，自备1500目1.8m*6安全网1000张，钢管2吨，脚手架500套。</p>
          </div>
        </li>
        <li>
          <div class="img">
            <img src="@/assets/tupian.png" alt="">
          </div>
          <div class="detail">
            <span>设备描述</span>
            <p>本施工队自建厂房，自备1500目1.8m*6安全网1000张，钢管2吨，脚手架500套。</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
.device{
    .device-list{
        background-color: #fff;
        ul{
            border: 1px solid #E4E7ED;
            li{
                display: flex;
                padding: 15px 20px;
                border-top: 1px solid #E4E7ED;
                &:first-child{
                    border-top: none;
                }
            }
            .img{
                width: 130px;
                height: 130px;
                border: 1px solid #E4E7ED;
                img{
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }
            .detail{
                flex: 1;
                margin-left: 30px;
                font-size: 14px;
                color: #333;
                p{
                    margin-top: 15px;
                    color: #666;
                }
            }
        }
    }
}
</style>
